export default "__VITE_ASSET__CPj$R4fl__"